import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import CreateCustomerPage from './app/customer/pages/Customer/CreateCustomer';
import CustomerPage from './app/customer/pages/Customer';
import { UpdateCustomerForm } from './app/customer/pages/Customer/UpdateCustomerForm';
import { CustomerContacts } from './app/customer/pages/CustomerContact/Contacts';
import CreateCustomerContactPage from './app/customer/pages/CustomerContact/CreateContact';
import UpdateCustomerContactPage from './app/customer/pages/CustomerContact/UpdateContact';
import CustomersPage from './app/customer/pages/Customers';
import { StatisticsPage } from './app/stats/pages/StatisticsPage';
import CreateInvoicePage from './app/sale/pages/sale/create';
import InvoicePage from './app/sale/pages/sale/details';
import { SalesInvoicesPage } from './app/sale/pages/Sales';
import LocationPage from './app/location/pages/Location';
import CreateLocationPage from './app/location/pages/Location/Create';
import { UpdateLocationForm } from './app/location/pages/Location/update';
import { LocationContacts } from './app/location/pages/LocationContact/Contacts';
import CreateLocationContactPage from './app/location/pages/LocationContact/CreateContact';
import UpdateLocationContactPage from './app/location/pages/LocationContact/UpdateContact';
import LocationsPage from './app/location/pages/Locations';
import LocationOpeningHours from './app/location/pages/OpeningHours';
import OrderConfirmationPage from './app/order/pages/confirmOrder/ConfirmOrder';
import OrderRefusalPage from './app/order/pages/confirmOrder/RefuseOrder';
import CreateOrderPage from './app/order/pages/order/Create';
import OrderPage from './app/order/pages/order/Order';
import { UpdateOrder } from './app/order/pages/order/UpdateOrder';
import CreateOrderLinePage from './app/order/pages/orderLine/CreateOrderLine';
import OrderLineDetails from './app/order/pages/orderLine/OrderLine';
import OrderLinesPage from './app/order/pages/orderLine/OrderLines';
import CreateOrderLineContentPage from './app/order/pages/orderLineContent/CreateOrderLineContent';
import OrderLineContentsPage from './app/order/pages/orderLineContent/OrderLineContents';
import { UpdateOrderLineContentPage } from './app/order/pages/orderLineContent/UpdateOrderLineContent';
import { CreateOrderLineSalePage } from './app/order/pages/orderLineSale/CreateOrderLineSale';
import { OrderLineSalesPage } from './app/order/pages/orderLineSale/OrderLineSales';
import { UpdateOrderLineSalePage } from './app/order/pages/orderLineSale/UpdateOrderLineSale';
import { CreateOrderPurchasePage } from './app/order/pages/orderPurchase/CreateOrderPurchase';
import { OrderPurchasesPage } from './app/order/pages/orderPurchase/OrderPurchases';
import { UpdateOrderPurchasePage } from './app/order/pages/orderPurchase/UpdateOrderPurchase';
import OrdersPage from './app/order/pages/Orders';
import SettingsPage from './app/settings/pages';
import IntegrationsPage from './app/settings/pages/integrations/IntegrationsPage';
import SupplierPage from './app/supplier/pages/Supplier';
import CreateSupplierPage from './app/supplier/pages/Supplier/CreateSupplier';
import { UpdateSupplierForm } from './app/supplier/pages/Supplier/UpdateSupplierForm';
import { SupplierContacts } from './app/supplier/pages/SupplierContact/Contacts';
import { SupplierUsersPage } from './app/supplier/pages/Supplier/SupplierUsers';
import CreateSupplierContactPage from './app/supplier/pages/SupplierContact/CreateContact';
import UpdateSupplierContactPage from './app/supplier/pages/SupplierContact/UpdateContact';
import SuppliersPage from './app/supplier/pages/Suppliers';
import { MePage } from './app/user/pages/Me';
import { Dashboard } from './components/page-templates/Dashboard';
import { AuthConsumer, AuthProvider, INTERNAL_ROLES } from './contexts/auth-context';
import { MinimalGeneralSettingsProvider } from './contexts/minimal-settings-context';
import CreditNotesPage from './app/creditnote/pages/CreditNotes';
import CreateCreditNotePage from './app/creditnote/pages/CreditNote/create';
import CreditNotePage from './app/creditnote/pages/CreditNote/details';
import PurchasesPage from './app/purchase/pages/Purchases';
import CreatePurchasePage from './app/purchase/pages/purchase/create/create';
import PurchasePage from './app/purchase/pages/purchase/details';
import { NotificationsProvider } from './app/notification/pages/context';
import NotificationsPage from './app/notification/pages/Notifications';
import { WebsocketProvider } from './contexts/websocket-context';
import IncomingDocsPage from './app/incoming-document/pages/IncomingDocs';
import IncomingDocPage from './app/incoming-document/pages/IncomingDoc';
import SelfBillingsPage from './app/self-billing/pages/SelfBills';
import SelfBillPage from './app/self-billing/pages/SelfBill';
import IncomingOrdersPage from './app/order/pages/incomingOrder/IncomingOrders';
import IncomingOrderPage from './app/order/pages/incomingOrder/IncomingOrder';
import { OrdersOverviewStats } from './app/stats/pages/OrdersOverview';
import { AccountingStats } from './app/stats/pages/AccountingStats';
import { ReportStatsV2 } from './app/stats/pages/ReportStatsV2';
import { DriverAppStats } from './app/stats/pages/DriverAppStats';
import { UserActivityStats } from './app/stats/pages/UserActivityStats';
import { AuditLogsPage } from './app/audit-log/pages/AuditLogs';
import { SelfBillKind } from 'src/types/enums';
import { InternalRole } from './app/auth/endpoints/MeEndpoint.types';
import { roleToNumber } from './app/auth/roles.client';
import QuotationsPage from './app/quotation/pages/Quotations';
import NewQuotationPage from './app/quotation/pages/NewQuotation';
import { QuotationPage } from './app/quotation/pages/Quotation';
import AIDraftPage from './app/quotation/pages/ai-draft/AIDraft';
import { FinancePage } from './app/finance/pages/FinancePage';
import { PlanningBoardPage } from './app/planning-board/pages/PlanningBoardPage';
import { SupplierTrucksPage } from './app/supplier/pages/SupplierTruck/SupplierTrucks';
import { CreateSupplierTruckPage } from './app/supplier/pages/SupplierTruck/CreateTruckPage';
import { UpdateSupplierTruckPage } from './app/supplier/pages/SupplierTruck/UpdateTruckPage';
import { OrderAuditLogsPage } from './app/order/pages/order/AuditLogs';
import { OrderTrackingPage } from './app/order/pages/order/OrderTracking';
import { AuditLogPage } from './app/audit-log/pages/AuditLog';
import { CustomerAuditLogsPage } from './app/customer/pages/Customer/AuditLogs';
import { SupplierAuditLogsPage } from './app/supplier/pages/Supplier/AuditLogs';
import { SupplierTrackingPage } from './app/supplier/pages/Supplier/Tracking';
import { LocationAuditLogsPage } from './app/location/pages/Location/AuditLogs';
import ForgotPasswordPage from './app/auth/pages/ForgotPassword';
import SetNewPasswordPage from './app/auth/pages/SetPassword';
import { CustomerUsersPage } from './app/customer/pages/Customer/CustomerUsers';
import { InviteCustomerUserPage } from './app/customer/pages/Customer/InviteCustomerUser';
import { InviteSupplierUserPage } from './app/supplier/pages/Supplier/InviteSupplierUser';
import { SupplierDriverDocumentsPage } from './app/supplier/pages/Supplier/SupplierDriverDocuments';
import { CustomerUserInvitePage } from './app/customer/pages/CustomerUserInvitePage';
import { SupplierUserInvitePage } from './app/supplier/pages/SupplierUserInvitePage';
import { CustomerPortalHomePage } from './app/customer-portal/HomePage';
import { CustomerPortalWrapper } from './app/customer-portal/CustomerPortalWrapper';
import { CustomerPortalUsersPage } from './app/customer-portal/users/CustomerPortalUsers';
import { CustomerPortalOrdersPage } from './app/customer-portal/orders/CustomerPortalOrders';
import { CustomerPortalOrderPage } from './app/customer-portal/orders/CustomerPortalOrder';
import { CustomerPortalMePage } from './app/customer-portal/users/CustomerPortalMe';
import { CustomerPortalUpdateCustomerDetailsPage } from './app/customer-portal/information/UpdateCustomerDetailsPage';
import { CustomerPortalContactsPage } from './app/customer-portal/contacts/CustomerPortalContactsPage';
import { CustomerPortalCreateContactPage } from './app/customer-portal/contacts/CustomerPortalCreateContact';
import { CustomerPortalUpdateContactPage } from './app/customer-portal/contacts/CustomerPortalUpdateContact';
import { InternalLoginPage } from './app/auth/pages/InternalLogin';
import { CustomerPortalLoginPage } from './app/auth/pages/CustomerPortalLogin';
import { Button } from './components/button/Button';
import { CustomerPortalQuotationsPage } from './app/customer-portal/quotations/Quotations';
import { CustomerPortalQuotationPage } from './app/customer-portal/quotations/Quotation';
import { CustomerPortalInvoicesPage } from './app/customer-portal/invoices/Invoices';
import { CustomerPortalInvoicePage } from './app/customer-portal/invoices/Invoice';
import { CustomerPortalPlaceOrderPage } from './app/customer-portal/orders/new/Create';
import { CustomerPortalChooseOrderMethodPage } from './app/customer-portal/orders/new/ChooseOrderMethod';
import { CustomerPortalAutomaticCreatePage } from './app/customer-portal/orders/new/AutomaticCreate';
import { CustomerPortalLocationsPage } from './app/customer-portal/locations/CustomerPortalLocationsPage';
import { CustomerPortalLocationPage } from './app/customer-portal/locations/CustomerPortalLocationPage';
import { CustomerPortalCreateLocationPage } from './app/customer-portal/locations/CustomerPortalCreateLocationPage';
import { PortalLoginPage } from './app/auth/pages/PortalLogin';
import { CarrierPortalWrapper } from './app/carrier-portal/CarrierPortalWrapper';
import { UserNotFoundPage } from './app/auth/pages/UserNotFoundPage';
import { OrderComplaintsPage } from './app/order/pages/order/OrderComplaints';
import { OrderChatPage } from './app/order/pages/order/OrderChat';
import { SpotMarketOffersPage } from './app/spot-pricing/components/SpotMarketOffers';
import { CreateManualSaleInvoicePage } from './app/sale/pages/sale/create-manual/CreateManualSaleInvoice';
import { CreateMultiOrdersFromOrderPage } from './app/order/pages/order/CreateMultiFrom';
import { CustomerPortalRequestAccountPage } from './app/customer-portal/users/CustomerPortalRequestAccountPage';
import { CustomerPortalRequestQuotationPage } from './app/customer-portal/quotations/CreateRequest';
import { CustomerPortalQuotationRequestsPage } from './app/customer-portal/quotations/Requests';
import { CustomerPortalQuotationRequestPage } from './app/customer-portal/quotations/Request';
import { QuotationRequestsPage } from './app/quotation-request/pages/Requests';
import { QuotationRequestPage } from './app/quotation-request/pages/Request';
import { PaymentRemindersPage } from './app/payment-reminder/pages/PaymentRemindersPage';
import { CreatePaymentReminderPage } from './app/payment-reminder/pages/create/CreatePaymentReminderPage';
import { PaymentReminderPage } from './app/payment-reminder/pages/PaymentReminderPage';
import { TrailersPage } from './app/trailer/pages/TrailersPage';
import { TrailersMapPage } from './app/trailer/pages/TrailersMapPage';
import { TrailersOverviewPage } from './app/trailer/pages/TrailersOverviewPage';
import { CreateTrailerPage } from './app/trailer/pages/CreateTrailerPage';
import { TrailerPage } from './app/trailer/pages/TrailerPage';
import { UpdateTrailerForm } from './app/trailer/pages/UpdateTrailerPage';
import { TrailerAuditLogs } from './app/trailer/pages/AuditLogs';
import { TrailerCostsPage } from './app/trailer/pages/costs/TrailerCosts';
import { CreateTrailerCostForm } from './app/trailer/pages/costs/CreateTrailerCost';
import { UpdateTrailerCostForm } from './app/trailer/pages/costs/UpdateTrailerCost';
import { TrailerChecksPage } from './app/trailer/pages/TrailerChecks';
import { TrailerCheckDetailPage } from './app/trailer/pages/TrailerCheckDetail';
import { CreateTrailerCheckPage } from './app/trailer/pages/CreateTrailerCheck';
import { SustainabilityReportPage as CustomerPortalSustainabilityReportPage } from './app/customer-portal/sustainability/SustainabilityReportPage';
import { CustomerPortalCreditNotesPage } from './app/customer-portal/creditnotes/CreditNotes';
import { CustomerPortalCreditNotePage } from './app/customer-portal/creditnotes/CreditNote';
import { OurInformationPage } from './app/customer-portal/information/OurInformationPage';
import { CustomerSelectionPage } from './app/customer-portal/customer-select/CustomerSelectionPage';
import { CustomerPortalSettingsPage } from './app/customer-portal/settings/CustomerPortalSettingsPage';
import { CustomerPortalApiKeysPage } from './app/customer-portal/api-keys/CustomerPortalApiKeysPage';
import { CustomerApiKeysTab } from './app/customer/pages/Customer/CustomerApiKeysTab';
import { CustomerApiLogsPage } from './app/customer/pages/Customer/CustomerApiLogsPage';
import { SalesStats } from './app/stats/pages/SalesStats';
import { CustomerSustainabilityReportingPage } from './app/customer/pages/Customer/SustainabilityReporting';
import { SustainabilityReportPage } from './app/sustainability/pages/SustainabilityPage';
import { CarrierPortalRequestAccountPage } from './app/carrier-portal/users/CarrierPortalRequestAccountPage';
import { CarrierSelectionPage } from './app/carrier-portal/carrier-select/CarrierSelectionPage';
import IncassosPage from './app/incasso/pages/Incassos';
import CreateIncassoPage from './app/incasso/pages/Incasso/create';
import IncassoPage from './app/incasso/pages/Incasso/details';
import { SettingsRoutes } from './app/settings/pages/SettingsRoutes';
import { CarrierPortalRoutes } from './app/carrier-portal/CarrierPortalRoutes';
import { CarrierPortalHomePage } from './app/carrier-portal/CarrierPortalHomePage';
import { ComplaintsPage } from './app/complaint/pages/ComplaintsPage';
import { TrackingLogsPage } from './app/tracking/pages/TrackingLogs';
import { DevLoginPage } from './app/dev/DevLoginPage';
import { FeatureFlagsPage } from './app/feature-flag/pages/FeatureFlagsPage';
import ClaimsPage from './app/claim/pages/ClaimsPage';
import CreateClaimPage from './app/claim/pages/CreateClaimPage';
import ClaimPage from './app/claim/pages/ClaimPage';

const DashboardRoute = () => {
  return (
    <AuthProvider fallbackLogin="/internal/login">
      <WebsocketProvider>
        <NotificationsProvider>
          <MinimalGeneralSettingsProvider>
            <Dashboard>
              <Outlet />
            </Dashboard>
          </MinimalGeneralSettingsProvider>
        </NotificationsProvider>
      </WebsocketProvider>
    </AuthProvider>
  );
};

const AuthRedirector: React.FC<{ fallbackLogin: string }> = ({ fallbackLogin }) => {
  return (
    <AuthProvider fallbackLogin={fallbackLogin}>
      <AuthConsumer>
        {(auth) => {
          if (!auth?.me) {
            return <Navigate to={fallbackLogin} replace />;
          }

          if (auth.me.isInternal || (auth.me.role && INTERNAL_ROLES.includes(auth.me.role))) {
            return <Navigate to="/internal" replace />;
          }

          if (auth.me.customers.length > 0) {
            const customerPath =
              auth.me.customers.length === 1
                ? `/customer-portal/${auth.me.customers[0].customer.id}`
                : '/customer-portal/select';
            return <Navigate to={customerPath} replace />;
          }

          if (auth.me.carriers.length > 0) {
            const carrierPath =
              auth.me.carriers.length === 1 ? `/carrier-portal/${auth.me.carriers[0].id}` : '/carrier-portal/select';
            return <Navigate to={carrierPath} replace />;
          }

          return (
            <div>
              <div>Invalid user state</div>

              <div>
                <Button onTrigger={() => auth.logout()}>Logout</Button>
              </div>
            </div>
          );
        }}
      </AuthConsumer>
    </AuthProvider>
  );
};

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/internal">
        {/** Internal Login */}
        <Route path="login" element={<InternalLoginPage />} />

        <Route path="*" element={<DashboardRoute />}>
          <Route
            index
            element={
              <AuthConsumer>
                {(auth) => {
                  const isAdmin = roleToNumber(auth?.me.role) >= roleToNumber(InternalRole.InternalAdmin);
                  return <Navigate to={isAdmin ? 'stats' : 'orders'} replace />;
                }}
              </AuthConsumer>
            }
          />
          <Route path="me" element={<MePage />} />
          <Route path="stats" element={<StatisticsPage />}>
            <Route index element={<Navigate to="overview" replace />} />
            <Route path="overview" element={<OrdersOverviewStats />} />
            <Route path="accounting" element={<AccountingStats />} />
            <Route path="truck-report" element={<ReportStatsV2 />} />
            <Route path="driver-app" element={<DriverAppStats />} />
            <Route path="user-activity" element={<UserActivityStats />} />
            <Route path="sales" element={<SalesStats />} />
          </Route>
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="suppliers">
            <Route index element={<SuppliersPage />} />
            <Route path="new" element={<CreateSupplierPage />} />
            <Route path=":supplierId" element={<SupplierPage />}>
              <Route index element={<Navigate to="general" replace />} />
              <Route path="general" element={<UpdateSupplierForm />} />
              <Route path="contacts">
                <Route index element={<SupplierContacts />} />
                <Route path="new" element={<CreateSupplierContactPage />} />
                <Route path=":supplierContactId" element={<UpdateSupplierContactPage />} />
              </Route>
              <Route path="trucks">
                <Route index element={<SupplierTrucksPage />} />
                <Route path="new" element={<CreateSupplierTruckPage />} />
                <Route path=":supplierTruckId" element={<UpdateSupplierTruckPage />} />
              </Route>
              <Route path="users">
                <Route index element={<SupplierUsersPage />} />
                <Route path="invite" element={<InviteSupplierUserPage />} />
              </Route>
              <Route path="driver-documents" element={<SupplierDriverDocumentsPage />} />
              <Route path="tracking" element={<SupplierTrackingPage />} />
              <Route path="audit-logs" element={<SupplierAuditLogsPage />} />
            </Route>
          </Route>
          <Route path="customers">
            <Route index element={<CustomersPage />} />
            <Route path="new" element={<CreateCustomerPage />} />
            <Route path=":customerId" element={<CustomerPage />}>
              <Route index element={<Navigate to="general" replace />} />
              <Route path="general" element={<UpdateCustomerForm />} />
              <Route path="contacts">
                <Route index element={<CustomerContacts />} />
                <Route path="new" element={<CreateCustomerContactPage />} />
                <Route path=":customerContactId" element={<UpdateCustomerContactPage />} />
              </Route>
              <Route path="users">
                <Route index element={<CustomerUsersPage />} />
                <Route path="invite" element={<InviteCustomerUserPage />} />
              </Route>
              <Route path="sustainability" element={<CustomerSustainabilityReportingPage />} />
              <Route path="api-keys">
                <Route index element={<CustomerApiKeysTab />} />
                <Route path="logs" element={<CustomerApiLogsPage />} />
              </Route>
              <Route path="audit-logs" element={<CustomerAuditLogsPage />} />
            </Route>
          </Route>
          <Route path="locations">
            <Route index element={<LocationsPage />} />
            <Route path="new" element={<CreateLocationPage />} />
            <Route path=":locationId" element={<LocationPage />}>
              <Route index element={<Navigate to="general" replace />} />
              <Route path="general" element={<UpdateLocationForm />} />
              <Route path="opening-hours" element={<LocationOpeningHours />} />
              <Route path="contacts">
                <Route index element={<LocationContacts />} />
                <Route path="new" element={<CreateLocationContactPage />} />
                <Route path=":locationContactId" element={<UpdateLocationContactPage />} />
              </Route>
              <Route path="audit-logs" element={<LocationAuditLogsPage />} />
            </Route>
          </Route>
          <Route path="orders">
            <Route index element={<OrdersPage />} />
            <Route path="new" element={<CreateOrderPage />} />
            <Route path="new-from-template" element={<CreateMultiOrdersFromOrderPage />} />
            <Route path="incoming">
              <Route index element={<IncomingOrdersPage />} />
              <Route path=":orderEmailId" element={<IncomingOrderPage />} />
            </Route>
            <Route path=":orderId" element={<OrderPage />}>
              <Route index element={<Navigate to="general" replace />} />
              <Route path="general" element={<UpdateOrder />} />
              <Route path="complaints" element={<OrderComplaintsPage />} />
              <Route path="lines">
                <Route index element={<OrderLinesPage />} />
                <Route path="new" element={<CreateOrderLinePage />} />
                <Route path=":orderLineId" element={<OrderLineDetails />}>
                  <Route path="contents">
                    <Route index element={<OrderLineContentsPage />} />
                    <Route path="new" element={<CreateOrderLineContentPage />} />
                    <Route path=":orderLineContentId" element={<UpdateOrderLineContentPage />} />
                  </Route>
                  <Route path="purchases">
                    <Route index element={<OrderPurchasesPage />} />
                    <Route path="new" element={<CreateOrderPurchasePage />} />
                    <Route path=":orderPurchaseId" element={<UpdateOrderPurchasePage />} />
                  </Route>
                  <Route path="sales">
                    <Route index element={<OrderLineSalesPage />} />
                    <Route path="new" element={<CreateOrderLineSalePage />} />
                    <Route path=":orderLineSaleId" element={<UpdateOrderLineSalePage />} />
                  </Route>
                </Route>
              </Route>
              <Route path="tracking" element={<OrderTrackingPage />} />
              {/* The documents tab merged into the documents bar on the general tab; keep old links working. */}
              <Route path="documents" element={<Navigate to="../general" replace />} />
              <Route path="chat" element={<OrderChatPage />} />
              <Route path="spot-market" element={<SpotMarketOffersPage />} />
              <Route path="audit-logs" element={<OrderAuditLogsPage />} />
            </Route>
          </Route>
          <Route path="complaints" element={<ComplaintsPage />} />
          <Route path="sustainability" element={<SustainabilityReportPage />} />
          <Route path="planning" element={<Navigate to="/internal/planning-board" replace />} />
          <Route path="planning-board" element={<PlanningBoardPage />} />
          <Route path="incoming-docs">
            <Route index element={<IncomingDocsPage />} />
            <Route path=":incomingDocId" element={<IncomingDocPage />} />
          </Route>
          <Route path="trailers">
            <Route index element={<Navigate to="overview" replace />} />
            <Route path="overview" element={<TrailersOverviewPage />} />
            <Route path="list" element={<TrailersPage />} />
            <Route path="map" element={<TrailersMapPage />} />
            <Route path="new" element={<CreateTrailerPage />} />
            <Route path=":trailerId" element={<TrailerPage />}>
              <Route index element={<Navigate to="general" replace />} />
              <Route path="general" element={<UpdateTrailerForm />} />
              <Route path="audit-logs" element={<TrailerAuditLogs />} />
              <Route path="costs">
                <Route index element={<TrailerCostsPage />} />
                <Route path="new" element={<CreateTrailerCostForm />} />
                <Route path=":trailerCostId" element={<UpdateTrailerCostForm />} />
              </Route>
              <Route path="checks">
                <Route index element={<TrailerChecksPage />} />
                <Route path="new" element={<CreateTrailerCheckPage />} />
                <Route path=":checkId" element={<TrailerCheckDetailPage />} />
              </Route>
            </Route>
          </Route>
          <Route path="finance">
            <Route index element={<FinancePage />} />
            <Route path="sales">
              <Route index element={<SalesInvoicesPage />} />
              <Route path="new" element={<CreateInvoicePage />} />
              <Route path="new-manual" element={<CreateManualSaleInvoicePage />} />
              <Route path=":saleId" element={<InvoicePage />} />
            </Route>
            <Route path="quotations">
              <Route index element={<QuotationsPage />} />
              <Route path="new" element={<NewQuotationPage />} />
              <Route path="ai-draft" element={<AIDraftPage />} />
              <Route path=":quotationId" element={<QuotationPage />} />
            </Route>
            <Route path="quotation-requests">
              <Route index element={<QuotationRequestsPage />} />
              <Route path=":quotationRequestId" element={<QuotationRequestPage />} />
            </Route>
            <Route path="purchases">
              <Route index element={<PurchasesPage />} />
              <Route path="new" element={<CreatePurchasePage />} />
              <Route path=":purchaseId" element={<PurchasePage />} />
            </Route>
            <Route path="creditnotes">
              <Route index element={<CreditNotesPage />} />
              <Route path="new" element={<CreateCreditNotePage />} />
              <Route path=":creditNoteId" element={<CreditNotePage />} />
            </Route>
            <Route path="ride-overviews">
              <Route
                index
                element={<SelfBillingsPage key={SelfBillKind.RideOverview} kind={SelfBillKind.RideOverview} />}
              />
              <Route
                path=":selfBillId"
                element={<SelfBillPage key={SelfBillKind.RideOverview} kind={SelfBillKind.RideOverview} />}
              />
            </Route>
            <Route path="self-billing">
              <Route
                index
                element={<SelfBillingsPage key={SelfBillKind.SelfBilling} kind={SelfBillKind.SelfBilling} />}
              />
              <Route
                path=":selfBillId"
                element={<SelfBillPage key={SelfBillKind.SelfBilling} kind={SelfBillKind.SelfBilling} />}
              />
            </Route>
            <Route path="payment-reminder">
              <Route index element={<PaymentRemindersPage />} />
              <Route path="new" element={<CreatePaymentReminderPage />} />
              <Route path=":paymentReminderId" element={<PaymentReminderPage />} />
            </Route>
            <Route path="incasso">
              <Route index element={<IncassosPage />} />
              <Route path="new" element={<CreateIncassoPage />} />
              <Route path=":incassoId" element={<IncassoPage />} />
            </Route>
            <Route path="claims">
              <Route index element={<ClaimsPage />} />
              <Route path="new" element={<CreateClaimPage />} />
              <Route path=":claimId" element={<ClaimPage />} />
            </Route>
          </Route>
          <Route path="settings" element={<SettingsPage />}>
            <Route path="*" element={<SettingsRoutes />} />
          </Route>
          <Route path="integrations/*" element={<IntegrationsPage />} />
          <Route path="audit-logs">
            <Route index element={<AuditLogsPage />} />
            <Route path=":auditLogId" element={<AuditLogPage />} />
          </Route>
          <Route path="tracking-logs">
            <Route index element={<TrackingLogsPage />} />
          </Route>
          <Route path="feature-flags" element={<FeatureFlagsPage />} />
          <Route path="*" element={<p>Pagina niet gevonden</p>} />
        </Route>
      </Route>

      <Route path="/customer-portal">
        <Route index element={<AuthRedirector fallbackLogin="/customer-portal/login" />} />

        {/** Customer Portal Login */}
        <Route path="login" element={<CustomerPortalLoginPage />} />

        <Route
          path="select"
          element={
            <AuthProvider fallbackLogin="/customer-portal/login">
              <CustomerSelectionPage />
            </AuthProvider>
          }
        />

        <Route path=":customerId" element={<CustomerPortalWrapper />}>
          <Route index element={<CustomerPortalHomePage />} />
          <Route path="orders">
            <Route index element={<CustomerPortalOrdersPage />} />
            <Route path="new">
              <Route index element={<CustomerPortalChooseOrderMethodPage />} />
              <Route path="manual" element={<CustomerPortalPlaceOrderPage />} />
              <Route path="automatic" element={<CustomerPortalAutomaticCreatePage />} />
            </Route>
            <Route path=":orderId" element={<CustomerPortalOrderPage />} />
          </Route>
          <Route path="locations">
            <Route index element={<CustomerPortalLocationsPage />} />
            <Route path="new" element={<CustomerPortalCreateLocationPage />} />
            <Route path=":locationId" element={<CustomerPortalLocationPage />} />
          </Route>
          <Route path="quotations">
            <Route index element={<CustomerPortalQuotationsPage />} />
            <Route path="requests">
              <Route index element={<CustomerPortalQuotationRequestsPage />} />
              <Route path="new" element={<CustomerPortalRequestQuotationPage />} />
              <Route path=":quotationRequestId" element={<CustomerPortalQuotationRequestPage />} />
            </Route>
            <Route path=":quotationId" element={<CustomerPortalQuotationPage />} />
          </Route>
          <Route path="invoices">
            <Route index element={<CustomerPortalInvoicesPage />} />
            <Route path=":invoiceId" element={<CustomerPortalInvoicePage />} />
          </Route>
          <Route path="creditnotes">
            <Route index element={<CustomerPortalCreditNotesPage />} />
            <Route path=":creditNoteId" element={<CustomerPortalCreditNotePage />} />
          </Route>
          <Route path="sustainability">
            <Route index element={<CustomerPortalSustainabilityReportPage />} />
          </Route>
          <Route path="users">
            <Route index element={<CustomerPortalUsersPage />} />
          </Route>
          <Route path="me" element={<CustomerPortalMePage />} />
          <Route path="business-information" element={<CustomerPortalUpdateCustomerDetailsPage />} />
          <Route path="our-information" element={<OurInformationPage />} />
          <Route path="contacts">
            <Route index element={<CustomerPortalContactsPage />} />
            <Route path="new" element={<CustomerPortalCreateContactPage />} />
            <Route path=":customerContactId" element={<CustomerPortalUpdateContactPage />} />
          </Route>
          <Route path="settings" element={<CustomerPortalSettingsPage />}>
            <Route index element={<Navigate to="api-keys" replace />} />
            <Route path="api-keys" element={<CustomerPortalApiKeysPage />} />
          </Route>
          <Route path="*" element={<Navigate to="." replace />} />
        </Route>
      </Route>

      {/** Generic Portal Route */}
      <Route path="/portal/login" element={<PortalLoginPage />} />

      {/** Carrier Portal */}
      <Route path="/carrier-portal">
        <Route index element={<AuthRedirector fallbackLogin="/portal/login" />} />

        <Route path="login" element={<PortalLoginPage />} />

        <Route
          path="select"
          element={
            <AuthProvider fallbackLogin="/portal/login">
              <CarrierSelectionPage />
            </AuthProvider>
          }
        />

        <Route path=":carrierId" element={<CarrierPortalWrapper />}>
          <Route index element={<CarrierPortalHomePage />} />
          <Route path="*" element={<CarrierPortalRoutes />} />
        </Route>
      </Route>

      {/** Supplier routes */}
      <Route path="/confirm-order" element={<OrderConfirmationPage />} />
      <Route path="/refuse-order" element={<OrderRefusalPage />} />

      {/** Legacy login URL — redirect without adding a history entry */}
      <Route path="/login" element={<Navigate to="/portal/login" replace />} />

      {/** General auth logic */}
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/set-new-password" element={<SetNewPasswordPage />} />
      <Route path="/customer-user-invite" element={<CustomerUserInvitePage />} />
      <Route path="/carrier-user-invite" element={<SupplierUserInvitePage />} />
      <Route path="/user-not-found" element={<UserNotFoundPage />} />
      <Route path="/request-customer-portal-account" element={<CustomerPortalRequestAccountPage />} />
      <Route path="/request-carrier-portal-account" element={<CarrierPortalRequestAccountPage />} />

      <Route path="/dev" element={<DevLoginPage />} />

      {/**
       * Later move this to navigate to /customer-portal/login as we don't wanna expose internals to the outside world
       **/}
      <Route path="*" element={<AuthRedirector fallbackLogin="/portal/login" />} />
    </Routes>
  );
};
